import { TimeZone } from "./TimeZone";

export const getLocalTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone as TimeZone;
